import { render, staticRenderFns } from "./AccountIndex.vue?vue&type=template&id=6c4b9c8b&scoped=true&"
import script from "./AccountIndex.vue?vue&type=script&lang=js&"
export * from "./AccountIndex.vue?vue&type=script&lang=js&"
import style0 from "./AccountIndex.vue?vue&type=style&index=0&id=6c4b9c8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4b9c8b",
  null
  
)

export default component.exports